import '@babylonjs/core/Engines/Extensions/engine.rawTexture';
import '@babylonjs/core/Materials/Textures/rawTexture';

import { assetPicker } from '@naker/design/Pickers/assetPicker';
import { colorPicker } from '@naker/design/Pickers/colorPicker';
import { ToolBox } from '@naker/design/Layers/toolBox';
import { NakerDropzone } from '@naker/design/Pickers/dropzone';
import { ExportModal } from '@naker/design/User/exportModal';

import { particleInterface } from './viewer/particle';
import { environmentInterface } from './viewer/environment';
import { geometrySettingsClass } from './editor/geometrySettings';
import { AnimationSettings } from './editor/animationSettings';
import { presetSettingsClass, presets } from './editor/presetSettings';
import { colorSettingsClass } from './editor/colorSettings';
import { backInterface } from './viewer/back';
import { particleList } from './editor/service/particleList';
import { backEngine, session, undo } from './editor/service/session';

import { setStyle } from 'redom';

import '../styles/interface.sass';

// For offline test
// import imageTest from '../styles/BackWhite.png';

'use strict';

window.onload = () => {

    for (let i = 0; i < particleList.length; i++) {
        let asset = particleList[i];
        assetPicker.addAsset('image', asset.url, asset.thumbnail, false, false);
    }
    
    let environmentOptions: environmentInterface, particle1Options: particleInterface;
    session.loadProject((project) => {
        
        // For some reason unknown, we can saved bad empty project
        // That's why we check project return is correct with Naker.Back engine
        if (project && project.json && project.json.environment && project.json.environment.colorStart) {
            let json: backInterface = project.json;
            environmentOptions = json.environment;
            particle1Options = json.particle;
            
            // For offline test
            // particle1Options.texture = imageTest;
            if (json.assets) assetPicker.initThumbnails(json.assets);
            if (json.palette) colorPicker.setPalette(json.palette);
        } else {
            let project = presets[4];
            particle1Options = project.particle;
            environmentOptions = project.environment;
        }
        
        backEngine.environment.setOptions(environmentOptions);
        backEngine.particle.setOptions(particle1Options);
        // Once option setted, we can add the background for transparent colors
        let container = document.getElementById("container");
        let svg = 'data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path fill="darkgrey" d="M1,0H2V1H1V0ZM0,1H1V2H0V1Z"/><path fill="gray" d="M0,0H1V1H0V0ZM1,1H2V2H1V1Z"/></svg>';
        setStyle(container, { "background-image": "url('" + svg + "')" });
        // Once option setted, we can save a first time
        undo.saveState();
        
        let exportModal = new ExportModal(session, undo, 'back', 'v1.0.9');
        let presetSettings = new presetSettingsClass(session, undo, exportModal, backEngine.environment, backEngine.particle);
        let colorSettings = new colorSettingsClass(undo, backEngine.environment, backEngine.particle);
        let geometrySettings = new geometrySettingsClass(undo, backEngine.particle);
        let animationSettings = new AnimationSettings(undo, backEngine.particle, backEngine.environment);
        presetSettings.setEditors(geometrySettings, animationSettings, colorSettings);
        // presetSettings.checkProjectJson(json);

        assetPicker.setParent(container);
        assetPicker.on('focus', (type: string) => {
            presetSettings.hideTemplatePicker();
        });
        let imageDropzone = new NakerDropzone('image', ["png"], 0.1);
        imageDropzone.setinPicker();
        imageDropzone.addProgressBar(container, '#ff0872');

        let toolBox = new ToolBox(container);
        toolBox.addUndo(undo);
        // toolBox.addPerformance(backEngine.system.canvas, container, backEngine.system.scene);
    });
};